import { Alert, Anchor, List } from '@mantine/core';
import { AlertCircle } from 'react-feather';
import type { IssueTarget, SetupIssue } from '../model/steps';

interface IssuesAlertProps {
  issues: SetupIssue[];
  /** On Review the headline counts blocking issues; elsewhere it counts this page's. */
  onReview: boolean;
  onFix: (target: IssueTarget) => void;
}

function headline(issues: SetupIssue[], onReview: boolean): string {
  const n = issues.length;
  if (!onReview)
    return `${n} ${n === 1 ? 'issue' : 'issues'} to fix on this page`;
  const blocking = issues.filter(i => i.blocks).length;
  if (blocking > 0)
    return `Fix ${blocking} ${blocking === 1 ? 'issue' : 'issues'} before you can start matching`;
  return `${n} ${n === 1 ? 'issue' : 'issues'} to review before you start`;
}

export function IssuesAlert({ issues, onReview, onFix }: IssuesAlertProps) {
  if (issues.length === 0) return null;
  return (
    <Alert
      color="dangerRed"
      variant="light"
      icon={<AlertCircle size={20} />}
      title={headline(issues, onReview)}
      mb="lg"
    >
      <List size="sm" spacing={6}>
        {issues.map(issue => (
          <List.Item key={issue.text}>
            {issue.text}{' '}
            <Anchor
              component="button"
              type="button"
              size="sm"
              fw={700}
              c="dangerRed.8"
              onClick={() => onFix(issue.target)}
            >
              Fix
            </Anchor>
          </List.Item>
        ))}
      </List>
    </Alert>
  );
}
